import { render, staticRenderFns } from "./FacebookLoginComponent.vue?vue&type=template&id=7c659edf&scoped=true"
import script from "./FacebookLoginComponent.vue?vue&type=script&lang=js"
export * from "./FacebookLoginComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c659edf",
  null
  
)

export default component.exports